import React, { useContext, useState, useEffect } from "react";
import { Card, Button, Input, Form, List, message } from "antd";
import { UserContext } from "../../UserContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const QuizEditor = () => {
    const {course} = useParams();
	const [messageApi, contextHolder] = message.useMessage();
	const [editingLevel, setEditingLevel] = useState(null);
    const {state} = useLocation();
	const [updatedQuiz, setUpdatedQuiz] = useState();
	const { instructorapiuri, token } = useContext(UserContext);
const navigate = useNavigate();

    const ktData = async () => {
			try {
				const response = await fetch(
					`${instructorapiuri}/inst/${course}/kt`,
					{
						method: "POST",
						headers: {
							Authorization: "BEARER: " + token,
						},
                        body:JSON.stringify({
                            prereq:state?.prereq
                        })
					}
				);
				const data = await response.json();
				console.log(data);
				if (data.data) {
                    		setUpdatedQuiz(data.data);
                            window.location.reload();
				} else {

				}
			} catch (error) {
				console.error("Error fetching prereq:", error);
			}
		};



	// useEffect(() => {
	// 	ktData()
	// }, []);

	useEffect(() => {
		setUpdatedQuiz(state?.quizData);
	}, []);

    console.log(state.quizData)

	const handleEdit = (level) => {
		setEditingLevel(level);
		console.log(level);
	};

	const handleSave = () => {
		if (editingLevel === "easy")
			saveUpdatedQuizToApi(course, "e", updatedQuiz.easy);
		else if (editingLevel === "medium")
			saveUpdatedQuizToApi(course,  "m", updatedQuiz.medium);
		else if (editingLevel === "hard")
			saveUpdatedQuizToApi(course, "h", updatedQuiz.hard);
		setEditingLevel(null);
	};

	const saveUpdatedQuizToApi = async (
		courseId,
		level,
		updatedQuiz
	) => {
		try {
            console.log(courseId, level, updatedQuiz);
			const response = await fetch(
				`${instructorapiuri}/inst/${courseId}/kt/${level}`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: "Bearer " + token,
					},
					body: JSON.stringify({ content: updatedQuiz }),
				}
			);

			if (!response.ok) {
				throw new Error("Network error");
			}

			const data = await response.json();
			messageApi.open({
                type: "success",
				content: `KT content modified Successfully...!`,
			});
            // navigate(`/teacher/courses/${course}/kt`, {
            //             replace: true,
            //             state: {
            //                 quizData: updatedQuiz,
            //             },
            //         });
		} catch (error) {
			console.error("Error updating quiz:", error.message);
		}
	};

	const handleInputChange = (level, index, field, value) => {
		setUpdatedQuiz((prevQuiz) => {
			const updatedQuestions = { ...prevQuiz };
			updatedQuestions[level][index][field] = value;
			return updatedQuestions;
		});
	};

	const renderQuestionItem = (level, item, index) => (
		<List.Item>
			<Form layout="vertical">
				<Form.Item label={`Question ${index + 1}`}>
					<Input
						value={item.question}
						onChange={(e) =>
							handleInputChange(level, index, "question", e.target.value)
						}
						disabled={editingLevel !== level}
					/>
				</Form.Item>
				<Form.Item label="Options">
					{item.options.map((option, optionIndex) => (
						<Input
							key={optionIndex}
							value={option}
							onChange={(e) =>
								handleInputChange(
									level,
									index,
									"options",
									updateOption(item.options, optionIndex, e.target.value)
								)
							}
							disabled={editingLevel !== level}
							style={{ marginBottom: "8px" }}
						/>
					))}
				</Form.Item>
				<Form.Item label="Correct Option">
					<Input
						value={item.correctOption.toString()}
						onChange={(e) =>
							handleInputChange(
								level,
								index,
								"correctOption",
								parseInt(e.target.value, 10)
							)
						}
						disabled={editingLevel !== level}
					/>
				</Form.Item>
			</Form>
		</List.Item>
	);

	const updateOption = (options, index, value) => {
		const updatedOptions = [...options];
		updatedOptions[index] = value;
		return updatedOptions;
	};


    const handlePublish=async()=>{
        try {
				const response = await fetch(
					`${instructorapiuri}/inst/publish/${course}`,
					{
						method: "POST",
						headers: {
							Authorization: "BEARER: " + token,
						}
					}
				);
				const data = await response.json();
				console.log(data);
				if (data.status==="success") {
                    messageApi.open({
											type: "success",
											content: `Course Published Successfully...!`,
										});	
navigate(`/teacher/mycourses/`, {
	replace: true
});
				}
			} catch (error) {
				console.error("Error fetching prereq:", error);
			}
    }

		return (
			<>
				{["easy", "medium", "hard"].map((level) => (
					<Card
						key={level}
						title={`${level.charAt(0).toUpperCase()}${level.slice(
							1
						)} Level Quiz`}
						style={{ width: "600px", margin: "20px" }}>
						{editingLevel === level ? (
							<List
								dataSource={updatedQuiz[level]}
								renderItem={(item, index) =>
									renderQuestionItem(level, item, index)
								}
								bordered
								size="small"
								keyExtractor={(item, index) => index.toString()}
							/>
						) : (
							<List
								dataSource={state?.quizData[level]}
								renderItem={(item, index) => (
									<List.Item key={index}>{item.question}</List.Item>
								)}
								bordered
								size="small"
								keyExtractor={(item, index) => index.toString()}
							/>
						)}
						{editingLevel === level ? (
							<Button
								type="primary"
								onClick={handleSave}
								style={{ marginTop: "10px" }}>
								Save
							</Button>
						) : (
							<Button
								type="primary"
								onClick={() => handleEdit(level)}
								style={{ marginTop: "10px" }}>
								Edit
							</Button>
						)}
					</Card>
				))}
				<Button
					type="primary"
					onClick={handlePublish}
					style={{ marginTop: "10px" }}>
					Publish
				</Button>
			</>
		);
};

export default QuizEditor;
